import { render, staticRenderFns } from "./modalImage.vue?vue&type=template&id=ed0da714&scoped=true&"
import script from "./modalImage.vue?vue&type=script&lang=js&"
export * from "./modalImage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=ed0da714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0da714",
  null
  
)

export default component.exports